import React from "react";

import { useIntl } from "react-intl";

import todayOrYesterday from "Libs/datetime";
import Tooltip from "src/organization/pages/project/environment/metrics/components/tooltip";
import {
  Flex,
  Table,
  TableRow,
  Td
} from "src/organization/pages/project/environment/metrics/components/tooltip/style";

import RoundLegend from "../components/RoundLegend";
import { formatNumber, formatPercent } from "../helper";
import { CursorDataSyncType } from "../types";

import { DateTime } from "./style";
import { HttpRequestSeries, HttpRequestSeriesPoint } from "./type";
import { statusColorBands } from "./utils";

type TooltipContentProps = {
  cursorSync?: CursorDataSyncType<HttpRequestSeriesPoint>;
  series: HttpRequestSeries[];
};

const RequestTooltip = (props: TooltipContentProps) => {
  const intl = useIntl();
  const { chartRect, adaptedCursor } = props.cursorSync || {};
  const { indexedData, tooltipIsPositionable } = adaptedCursor || {};

  const data = indexedData?.data;

  const [xx1, xx2, xx3, xx4, xx5] = [
    data?.["1XX"] || 0,
    data?.["2XX"] || 0,
    data?.["3XX"] || 0,
    data?.["4XX"] || 0,
    data?.["5XX"] || 0
  ];

  const statusSum = xx1 + xx2 + xx3 + xx4 + xx5;

  return (
    <Tooltip
      chartRect={chartRect}
      isVisible={tooltipIsPositionable}
      adaptedCursor={adaptedCursor}
    >
      <Table>
        <tbody>
          <TableRow>
            <DateTime colSpan={2}>{todayOrYesterday(data?.date)}</DateTime>
          </TableRow>
          <TableRow isActive>
            <Td>{formatNumber({ value: statusSum })}</Td>
            <Td bold colSpan={2}>
              {intl.formatMessage({ id: "total" })}
            </Td>
          </TableRow>
          <TableRow>
            <Td>
              <Flex>
                <RoundLegend color={statusColorBands["1XX"]} />
                <span className="bold">{formatPercent(xx1, statusSum)}</span>
              </Flex>
            </Td>
            <Td>{formatNumber({ value: xx1 })} </Td>
            <Td>{intl.formatMessage({ id: "1XX_information" })}</Td>
          </TableRow>
          <TableRow>
            <Td>
              <Flex>
                <RoundLegend color={statusColorBands["2XX"]} />
                <span className="bold">{formatPercent(xx2, statusSum)}</span>
              </Flex>
            </Td>
            <Td>{formatNumber({ value: xx2 })} </Td>
            <Td>{intl.formatMessage({ id: "2XX_success" })}</Td>
          </TableRow>
          <TableRow>
            <Td>
              <Flex>
                <RoundLegend color={statusColorBands["3XX"]} />
                <span className="bold"> {formatPercent(xx3, statusSum)}</span>
              </Flex>
            </Td>
            <Td>{formatNumber({ value: xx3 })}</Td>
            <Td>{intl.formatMessage({ id: "3XX_redirect" })}</Td>
          </TableRow>
          <TableRow>
            <Td>
              <Flex>
                <RoundLegend color={statusColorBands["4XX"]} />
                <span className="bold"> {formatPercent(xx4, statusSum)}</span>
              </Flex>
            </Td>
            <Td>{formatNumber({ value: xx4 })}</Td>
            <Td>
              <span> {intl.formatMessage({ id: "4XX_client_error" })}</span>
            </Td>
          </TableRow>
          <TableRow>
            <Td>
              <Flex>
                <RoundLegend color={statusColorBands["5XX"]} />
                <span className="bold"> {formatPercent(xx5, statusSum)}</span>
              </Flex>
            </Td>
            <Td>{formatNumber({ value: xx5 })}</Td>
            <Td>{intl.formatMessage({ id: "5XX_server_error" })}</Td>
          </TableRow>
        </tbody>
      </Table>
    </Tooltip>
  );
};

export default RequestTooltip;
